/**
 * Het scherm van de leerkracht: vijf tabbladen, elk een eigen bestand in
 * tabs/. Dit bestand is alleen de kop en de tabbladmachine; een tabblad
 * haalt zelf op wat het nodig heeft zodra het opent.
 */
import React, { useState } from 'react';
import { MessageSquare, Users, ClipboardList, BarChart3 } from 'lucide-react';
import { kleur } from '../../theme/tokens';
import { maakApi } from '../../api/client';
import { maakLeerkrachtApi } from '../../api/leerkracht';
import { basis } from './stijlen';
import { Klassen } from './tabs/Klassen';
import { Stellingen } from './tabs/Stellingen';
import { Personas } from './tabs/Personas';
import { Sessies } from './tabs/Sessies';
import { Resultaten } from './tabs/Resultaten';

const TABS = [
  ['klassen', 'Klassen', Users],
  ['stellingen', 'Stellingen', MessageSquare],
  ['personas', "Persona's", Users],
  ['sessies', 'Sessies', ClipboardList],
  ['resultaten', 'Resultaten', BarChart3],
];

function LeerkrachtDashboard({ user, token, onLogout, apiUrl }) {
  const [tab, setTab] = useState('klassen');
  const { verzoek } = maakApi({ apiUrl, token, bijVerlopenToken: onLogout });
  const api = maakLeerkrachtApi(verzoek);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src="/socrates_logo.png" alt="Socrates" style={{ height: '125px' }} />
        <div style={styles.userInfo}>
          <span>{user.school_naam ? user.school_naam + ' | ' : ''}{user.naam}</span>
          <button onClick={onLogout} style={styles.logoutBtn}>Uitloggen</button>
        </div>
      </div>
      <div style={styles.tabs}>
        {TABS.map(([sleutel, naam, Icoon]) => (
          <button key={sleutel} style={tab === sleutel ? styles.tabActive : styles.tab} onClick={() => setTab(sleutel)}>
            <Icoon size={16} style={{ marginRight: '6px', verticalAlign: 'middle' }} />{naam}
          </button>
        ))}
      </div>
      <div style={styles.content}>
        {tab === 'klassen' && <Klassen api={api} user={user} />}
        {tab === 'stellingen' && <Stellingen api={api} />}
        {tab === 'personas' && <Personas api={api} apiUrl={apiUrl} />}
        {tab === 'sessies' && <Sessies api={api} />}
        {tab === 'resultaten' && <Resultaten api={api} />}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  header: { background: 'white', color: kleur.inkt, padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  userInfo: { display: 'flex', alignItems: 'center', gap: '16px' },
  tabs: { display: 'flex', background: 'white', borderBottom: '1px solid black', padding: '0 24px' },
  content: { padding: '24px' },
};

export default LeerkrachtDashboard;
